// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import TilesContainer from '../tilesContainer';
import { tracker, UserActionType } from '../../../tracking';
import style from './style.css';
import OffersCard from '../offersCard';
import CustomSlider from '../../common/customSlider';
import { connect } from 'react-redux';
import { offersInstacred } from '../../../alias/homeRoutes';
import howToBuyAction from '../../../actions/howToBuyActions';
import { useRef } from 'preact/hooks';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { useState, useEffect } from 'preact/hooks';

const TopOffers = (props) => {
  const { offers, pageKey, lenderDetailsList, userStatus } = props;
  const customSliderRef = useRef(null);
  const [offersToRender, setOffersToRender] = useState([]);

  useEffect(() => {
    if (userStatus === 'eligible') {
      const userRelevantOffers = new Set();
      offers.forEach((offer) => {
        for (let lender of lenderDetailsList) {
          if (offer.supportedLenders[lender.lenderId]) {
            userRelevantOffers.add(offer);
            break;
          }
        }
      });
      setOffersToRender(Array.from(userRelevantOffers));
    } else {
      setOffersToRender(offers);
    }
  }, [offers, userStatus]);

  return (
    <TilesContainer
      title='Hot Deals & Offers'
      subTitle='Spend less, save more with the latest deals'
      additionalButton={true}
      additionalButtonAction={() => {
        tracker.trackUserInteraction(
          UserActionType.CLICK,
          'bic_top_offers_see_more',
          pageKey,
        );
        return route(`${offersInstacred.path}${window.location.search}`);
      }}
      nextSlide={() => {
        customSliderRef.current.nextSlide();
      }}
      prevSlide={() => {
        customSliderRef.current.prevSlide();
      }}>
      <CustomSlider
        childWidth={415}
        outerContainerClass={style.topStoreOuterContainer}
        ref={customSliderRef}
        noOfSlides={offers.length}
        customSettings={{
          arrows: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              },
            },
          ],
        }}>
        {offersToRender.map((item, i) => {
          return (
            <div className={style.offersCardWrapper}>
              <OffersCard
                offerCardClick={() => {
                  tracker.trackUserInteraction(
                    UserActionType.CLICK,
                    'bic_offers_tile',
                    pageKey,
                    {
                      name: item.handle,
                      rank: i + 1,
                    },
                  );
                  return route(generateUrlWithParams(`offers-${item.handle}`));
                }}
                offerBackgroundImg={item.desktopImgUrl}
                offerText={item.altText}
                merchantName={item.name}
                index={i}
              />
            </div>
          );
        })}
      </CustomSlider>
    </TilesContainer>
  );
};
const mapStateToProps = ({ buyWithInstacred, ntbConfig }) => {
  const { home } = buyWithInstacred || {};
  const { offers } = home;
  const { ntbDetails, userStatus } = ntbConfig;
  const { lenderDetailsList } = ntbDetails;
  return {
    offers,
    lenderDetailsList,
    userStatus,
  };
};
export default connect(
  mapStateToProps,
  { howToBuyAction },
)(TopOffers);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/topOffers/index.js